import { render, staticRenderFns } from "./CreateUpdate.vue?vue&type=template&id=15bcac53&scoped=true&"
import script from "./CreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bcac53",
  null
  
)

export default component.exports